import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import moment from 'moment';

export class TimeFrame extends Field {
  static subqueriesForModel() {
    return { epoch: ['name'] };
  }

  get title() {
    return 'Time frame';
  }

  exampleContents(): FieldContentsData {
    return {
      text: `Q1 ${moment().add(1, 'year').format('YYYY')}`,
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.epoch) {
      return {
        text: record.epoch.name,
      };
    }

    return {};
  }
}
